export function getValidTranslation(translationValue: string | undefined): string | undefined {
  return translationValue && !/^\s*$/.test(translationValue) ? translationValue : undefined;
}
